import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Form,
  Image,
  Modal,
  Row,
} from "react-bootstrap";
import { FormattedMessage, injectIntl, useIntl } from "react-intl";
import rightBannerSvg from "../../assets/images/right_banner.png";
import parse from "html-react-parser";
import { useNavigate, useLocation } from "react-router";
import { ROLE } from "../../config/business";
import languages from "../../components/common/languages";
import { createOTP } from "../../services/api";

function ForgetPass(props) {
  const { intl, otpData, setotpData } = props;
  const shbLink = process.env.REACT_APP_SHB_SIGN_IN_LINK;
  let data = otpData.forgetPass;
  let message = otpData.message;
  

  const navigate = useNavigate();
  const location = useLocation();
  const [show, setshow] = useState(false);
  const uIntl = useIntl();

  const setloading = (loading) => {
    setotpData({...otpData, loading})
  }

  const setcheck = (check) => {
    setotpData({...otpData, check})
  }

  const updateOtpData = (obj)=> {
    setotpData({...obj})
  }
  const onSubmit = async (e) => {
    //call api validate & create otp
    if(!validateInfo()){
      showMessage({content: parse(intl.formatMessage({id: "forgetPass.error"}))})
      // showMessage();
      return;
    }
    setloading(true);
    createOTP(otpData.forgetPass).then(response => {
      setloading(false);
      if(response.data && response.data.content){
        if(response.data.content.STATUS == 'SUCCESS'){
          const resData = response.data && response.data.content && response.data.content.data;
          const countDown =  Math.floor(Date.now() / 1000) + resData.otpTimeout;
        
          updateOtpData({...otpData,
            check: true,
            verifyForm: {
              ...resData, countDown
            }});
          // setcheck(true);
        }else{
          showMessage({content: parse(intl.formatMessage({id: "forgetPass.error"}))})
          // showMessage();
        }
      }else{
        showMessage({content: parse(intl.formatMessage({id: "forgetPass.error"}))})
        // showMessage();
      }
    }).catch(err => {
      setloading(false);
      showMessage({content: parse(intl.formatMessage({id: "forgetPass.error"}))})
      // showMessage();
    })


  };

  const onBack = () => {
    // navigate("/")
    window.location.assign(shbLink);
  }

  const validateInfo = () => {
    console.log('otpData', otpData)
    if(!otpData.forgetPass.custId || !otpData.forgetPass.custId.trim()){
      return false
    }

    if(!otpData.forgetPass.role || !otpData.forgetPass.role.trim()){
      return false;
    }

    if(!otpData.forgetPass.email ||  !otpData.forgetPass.email.trim()){
      return false;
    }

    if(otpData.forgetPass.custId.length <= 1 || otpData.forgetPass.custId.length > 50){
      return false;
    }

    if(otpData.forgetPass.role === 'VIEWER_ALIAS'){
      if(!otpData.forgetPass.userName || !otpData.forgetPass.userName.trim() || otpData.forgetPass.userName.length > 250){
        return false;
      }
    }else if(!otpData.forgetPass.phone || !otpData.forgetPass.phone.trim()){
      return false;
    }
    
    return true;
  }


  const handleTextChange = (name, e) => {
    e.preventDefault();
    let _value = e.target.value;
    if(_value){
      _value = _value.trim();
    }
    setotpData({...otpData, forgetPass: {...otpData.forgetPass, [name]: _value}});
  };

  const handleSelectChange = (name, e) => {
    console.log('otpData', otpData);
    if(name === 'role'){
      setotpData({...otpData, forgetPass: {...otpData.forgetPass, [name]: e.target.value, userName: ''}})
    }else{
      setotpData({...otpData, forgetPass: {...otpData.forgetPass, [name]: e.target.value}})
    }
  };

  const showMessage = (msg) => {
    setotpData({...otpData, message: msg})
    setshow(true)
  }

  const closeDialog = () => {
    setshow(false);
    setotpData({...otpData, message: {tile: '', content: ''}})
  }

  useEffect(() => {
    setTimeout(() => {console.log(otpData)}, 2000)
  }, [otpData])
  

  return (

    <div>
      <Container className="container-collapse" style={{ paddingLeft: "90px" }}>
        <Row className="m-0 p-0">
          <Col xs={12} sm={5} md={5} lg={5} xl={5} xxl={5} className="m-0 p-0">
            <Col xs={12} sm={10} md={10} lg={10} xl={10} xxl={10} className="m-0 p-0">
            <div className="justify-content-center content-landing-page">
              <Card
                className="bg-transparent border-0"
              >
                <Card.Body className=" p-0">
                  <Card.Title
                    className="d-flex justify-content-center"
                    size="lg"
                  >
                    <FormattedMessage id={"forgetPass.title"} />
                  </Card.Title>
                  <Form.Group className="mb-3">
                    <Form.Label style={{fontWeight: "500"}} >
                    <FormattedMessage id={"forgetPass.code"} />
                    </Form.Label>
                    <Form.Control
                      value={otpData.forgetPass.custId}
                      onChange={(e) => handleTextChange("custId", e)}
                      // size="lg"
                      className="border-dark "
                      placeholder={parse(
                        intl.formatMessage({
                          id: "forgetPass.masodkkd_placeholder",
                        })
                      )}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label style={{fontWeight: "500"}} ><FormattedMessage id={"forgetPass.role"} />
                    </Form.Label>
                    <Form.Select
                      // size="lg"
                      className="border-dark"
                      onChange={(e) => {handleSelectChange("role", e)}}
                      value={otpData.forgetPass.role}
                    >
                      {ROLE.map((item, i) => (
                        <option key={i} value={item.value}>
                          {uIntl.locale === languages.vi
                            ? item.name
                            : item.name_EN}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-3" hidden={otpData.forgetPass.role !== 'VIEWER_ALIAS'}>
                    <Form.Label style={{fontWeight: "500"}} ><FormattedMessage id={"forgetPass.username"} />
                    </Form.Label>
                    <Form.Control
                      // size="lg"
                      className="border-dark"
                      placeholder={parse(
                        intl.formatMessage({
                          id: "forgetPass.placeholder_username",
                        })
                      )}
                      value={otpData.forgetPass.userName}
                      onChange={(e) => handleTextChange("userName", e)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label style={{fontWeight: "500"}} ><FormattedMessage id={"forgetPass.email"} />
                    </Form.Label>
                    <Form.Control
                      // size="lg"
                      className="border-dark"
                      placeholder={parse(
                        intl.formatMessage({
                          id: "forgetPass.placeholder_email",
                        })
                      )}
                      value={otpData.forgetPass.email}
                      onChange={(e) => handleTextChange("email", e)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" hidden={otpData.forgetPass.role === 'VIEWER_ALIAS'}>
                    <Form.Label  style={{fontWeight: "500"}} ><FormattedMessage id={"forgetPass.phone"} />
                    </Form.Label>
                    <Form.Control
                      // size="lg"
                      className="border-dark"
                      placeholder={parse(
                        intl.formatMessage({ id: "forgetPass.placeholder_sdt" })
                      )}
                      value={otpData.forgetPass.phone}
                      onChange={(e) => handleTextChange("phone", e)}
                    />
                  </Form.Group>

                  <Form.Group className="mt-3 mb-3 d-grid ">
                    <button
                      className="btn fill-submit-btn"
                      onClick={onSubmit}
                      disabled={otpData.forgetPass.otpTimeout === 0}
                     style={{fontWeight: "500"}} ><FormattedMessage id={"forgetPass.continue"} />
                    </button>
                  </Form.Group>

                  <Form.Group className="mb-3 d-grid">
                    <button className="btn outline-btn" onClick={onBack}  
                     style={{fontWeight: "500"}} ><FormattedMessage id={"forgetPass.back"} />
                     
                    </button>
                  </Form.Group>
                </Card.Body>
              </Card>
            </div>
            </Col>
          </Col>
          <Col
            xs={7}
            sm={7}
            md={7}
            lg={7}
            xl={7}
            xxl={7}
            style={{ textAlign: "right" }}
          >
            <Image src={rightBannerSvg} style={{ width: "100%" }}></Image>
          </Col>
        </Row>
        <Modal show={show}>
                <Modal.Body >
                  <div className="d-flex justify-content-center">
                  <p className="text-center" style={{width:"60%"}}>
                    {message.content}
                  </p>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn outline-btn"
                      onClick={closeDialog}
                    >
                      <FormattedMessage id={"verifyForm.close"} ></FormattedMessage>
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
      </Container>
    </div>
  );
}

export default injectIntl(ForgetPass);
